function dcCartCallBack (){
    console.log("Cart Callback")
    forceRefreshCartDrawer()  
}

async function forceRefreshCartDrawer() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;
  const sections = drawer.getSectionsToRender().map(s => s.section);
  const response = await fetch(`?sections=${sections.join(',')}`);
  const data = await response.json();
  drawer.renderContents({ sections: data }, true);
}
